export const REPORTING_DATE_FILTER_NAME = 'date' as const
export const REPORTING_OVERVIEW_USER_FILTER_NAME = 'userId' as const

export const reportingOverviewBlockTypes = [
  'messagesSent',
  'messagesReceived',
  'deliveryRate',
  'replyRate',
  'payments',
  'smsCosts',
] as const
export type ReportingOverviewBlockType = (typeof reportingOverviewBlockTypes)[number]
export type ReportingOverviewBlocks = Record<ReportingOverviewBlockType, ReportingOverviewBlock>
export type ReportingOverviewBlock = {
  count: number
  change: number
  isUp: boolean
}

export const reportingDeliveryRateTypes = [
  'accepted',
  'buffered',
  'delivered',
  'failed',
  'queued',
  'rejected',
  'sent',
] as const
export type ReportingDeliveryRateType = (typeof reportingDeliveryRateTypes)[number]
export type ReportingDeliveryRateChart = Record<ReportingDeliveryRateType, number>

export const reportingProductUsageTypes = [
  'online',
  'api',
  'e2s',
  'distributionLists',
  'messengers',
  'chat',
  'ios',
  'android',
  'automationRules',
  'desktop',
] as const
export type ReportingProductUsageType = (typeof reportingProductUsageTypes)[number]
export type ReportingProductUsageChart = Record<ReportingProductUsageType, number>

export type ReportingOverviewCharts = {
  deliveryRate: ReportingDeliveryRateChart
  productUsage: ReportingProductUsageChart
}
